import { render, staticRenderFns } from "./LoadPage.vue?vue&type=template&id=4fd004a8&"
import script from "./LoadPage.vue?vue&type=script&lang=js&"
export * from "./LoadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports